webpackJsonp([35783957827783],{

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	var emptyObject = __webpack_require__(43);
	var _invariant = __webpack_require__(1);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),

/***/ 291:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/fitso-logo.5dc1997d.jpg";

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/kayako-logo-2.c19c5f40.jpg";

/***/ }),

/***/ 474:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/gatsby-starter.20c5261f.png";

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/little-nomad.ac8c1a83.png";

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/snooze.744d56cd.png";

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/spotify-quiz.60ac3062.png";

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/wvwalkthroughview-optimize.90a2f265.gif";

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Section = __webpack_require__(127);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _ExperienceUnit = __webpack_require__(126);
	
	var _ExperienceUnit2 = _interopRequireDefault(_ExperienceUnit);
	
	var _zomatoLogo = __webpack_require__(474);
	
	var _zomatoLogo2 = _interopRequireDefault(_zomatoLogo);
	
	var _fitsoLogo = __webpack_require__(472);
	
	var _fitsoLogo2 = _interopRequireDefault(_fitsoLogo);
	
	var _kayakoLogo = __webpack_require__(473);
	
	var _kayakoLogo2 = _interopRequireDefault(_kayakoLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExperienceSection = function (_React$Component) {
	  _inherits(ExperienceSection, _React$Component);
	
	  function ExperienceSection() {
	    _classCallCheck(this, ExperienceSection);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ExperienceSection.prototype.render = function render() {
	    return _react2.default.createElement(
	      _Section2.default,
	      { title: 'Experience' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(_ExperienceUnit2.default, {
	          logo: _zomatoLogo2.default,
	          colour: '#CB202D',
	          title: 'Zomato',
	          link: 'https://www.zomato.com/',
	          timeperiod: '2014 - 2015',
	          subtitle: 'Learnt the ins and outs of product development and built various features including a completely new product.'
	        }),
	        _react2.default.createElement(_ExperienceUnit2.default, {
	          logo: _fitsoLogo2.default,
	          colour: '#FFFFFF',
	          title: 'Fitso',
	          link: 'https://www.getfitso.com/',
	          timeperiod: '2016',
	          subtitle: 'Built real time GPS tracking on the iOS app, all consumer facing web modules and external APIs in this early stage startup.'
	        }),
	        _react2.default.createElement(_ExperienceUnit2.default, {
	          logo: _kayakoLogo2.default,
	          colour: '#403949',
	          title: 'Kayako',
	          link: 'https://www.kayako.com/',
	          timeperiod: '2017 - 2018',
	          subtitle: 'Worked as a Product Engineer on email processing, push notifications, SLAs amongst other things.'
	        })
	      )
	    );
	  };
	
	  return ExperienceSection;
	}(_react2.default.Component);
	
	exports.default = ExperienceSection;
	module.exports = exports['default'];

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(361);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExperienceUnit = function (_Component) {
	  _inherits(ExperienceUnit, _Component);
	
	  function ExperienceUnit() {
	    _classCallCheck(this, ExperienceUnit);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ExperienceUnit.prototype.render = function render() {
	
	    var stylingClass = this.props.imageStyleCover === true ? 'cover' : 'contain';
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'experience-unit col-xs-12 col-sm-6 col-md-4' },
	      _react2.default.createElement(
	        'a',
	        { href: this.props.link, target: '_blank' },
	        _react2.default.createElement('div', {
	          className: "image " + stylingClass,
	          style: {
	            backgroundImage: 'url(' + this.props.logo + ')',
	            backgroundColor: this.props.colour
	          } })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'title bold' },
	        this.props.title
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'time-period' },
	        this.props.timeperiod
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'subtitle' },
	        this.props.subtitle
	      )
	    );
	  };
	
	  return ExperienceUnit;
	}(_react.Component);
	
	exports.default = ExperienceUnit;
	module.exports = exports['default'];

/***/ }),

/***/ 361:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Section = __webpack_require__(127);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _ExperienceUnit = __webpack_require__(126);
	
	var _ExperienceUnit2 = _interopRequireDefault(_ExperienceUnit);
	
	var _snooze = __webpack_require__(478);
	
	var _snooze2 = _interopRequireDefault(_snooze);
	
	var _gatsbyStarter = __webpack_require__(476);
	
	var _gatsbyStarter2 = _interopRequireDefault(_gatsbyStarter);
	
	var _spotifyQuiz = __webpack_require__(479);
	
	var _spotifyQuiz2 = _interopRequireDefault(_spotifyQuiz);
	
	var _littleNomad = __webpack_require__(477);
	
	var _littleNomad2 = _interopRequireDefault(_littleNomad);
	
	var _wvwalkthroughviewOptimize = __webpack_require__(480);
	
	var _wvwalkthroughviewOptimize2 = _interopRequireDefault(_wvwalkthroughviewOptimize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProjectsSection = function (_React$Component) {
	  _inherits(ProjectsSection, _React$Component);
	
	  function ProjectsSection() {
	    _classCallCheck(this, ProjectsSection);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ProjectsSection.prototype.render = function render() {
	    return _react2.default.createElement(
	      _Section2.default,
	      { title: 'Projects' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(_ExperienceUnit2.default, {
	          logo: _snooze2.default,
	          colour: '#FFFFFF',
	          title: 'Snooze',
	          link: 'https://github.com/praagyajoshi/snooze',
	          timeperiod: '2018',
	          subtitle: 'Sleep timer for Mac. Lives in the menubar, built with Swift.',
	          imageStyleCover: true
	        }),
	        _react2.default.createElement(_ExperienceUnit2.default, {
	          logo: _gatsbyStarter2.default,
	          colour: '#FFFFFF',
	          title: 'Gatsby Starter',
	          link: 'https://github.com/praagyajoshi/gatsby-starter-2column-portfolio',
	          timeperiod: '2018',
	          subtitle: 'A starter/theme for GatsbyJS which this website is based on. Made with React.',
	          imageStyleCover: true
	        }),
	        _react2.default.createElement(_ExperienceUnit2.default, {
	          logo: _littleNomad2.default,
	          colour: '#FFFFFF',
	          title: 'Little Nomad',
	          link: 'https://www.littlenomad.co/',
	          timeperiod: '2017 - ???',
	          subtitle: 'A platform for socially aware travellers. Runs on React+Redux with a Ruby on Rails backend.'
	        }),
	        _react2.default.createElement(_ExperienceUnit2.default, {
	          logo: _spotifyQuiz2.default,
	          colour: '#20DC6B',
	          title: 'Music Quiz for Spotify',
	          link: 'https://quiz.praagya.com/',
	          timeperiod: '2017',
	          subtitle: 'A fun quiz which tests your knowledge of music that you\'ve saved. Built using React/Redux.'
	        }),
	        _react2.default.createElement(_ExperienceUnit2.default, {
	          logo: _wvwalkthroughviewOptimize2.default,
	          colour: '#312F31',
	          title: 'WalkthroughView',
	          link: 'https://github.com/praagyajoshi/WVWalkthroughView',
	          timeperiod: '2016',
	          subtitle: 'A drop in utility to help onboard a new user/feature. Written in Objective C.'
	        })
	      )
	    );
	  };
	
	  return ProjectsSection;
	}(_react2.default.Component);
	
	exports.default = ProjectsSection;
	module.exports = exports['default'];

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(362);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Section = function (_Component) {
	  _inherits(Section, _Component);
	
	  function Section() {
	    _classCallCheck(this, Section);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Section.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'section' },
	      _react2.default.createElement(
	        'h6',
	        { className: 'bold' },
	        this.props.title
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'section-units' },
	        this.props.children
	      )
	    );
	  };
	
	  return Section;
	}(_react.Component);
	
	exports.default = Section;
	module.exports = exports['default'];

/***/ }),

/***/ 362:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(363);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var About = function (_Component) {
	  _inherits(About, _Component);
	
	  function About() {
	    _classCallCheck(this, About);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  About.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'about' },
	      _react2.default.createElement('div', { className: 'image' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'bio' },
	        'A technology enthusiast & certified scuba diver, who loves travelling, paints occasionally and follows football ardently.',
	        _react2.default.createElement(
	          'div',
	          { className: 'emoji' },
	          '\uD83E\uDD16 \xA0\uD83C\uDFD4\xA0\uD83C\uDFA8\xA0 \u26BD\uFE0F'
	        )
	      )
	    );
	  };
	
	  return About;
	}(_react.Component);
	
	exports.default = About;
	module.exports = exports['default'];

/***/ }),

/***/ 363:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(364);
	
	__webpack_require__(291);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Links = function (_Component) {
	  _inherits(Links, _Component);
	
	  function Links() {
	    _classCallCheck(this, Links);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Links.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'links' },
	      _react2.default.createElement(
	        'ul',
	        { className: 'icons-list' },
	        _react2.default.createElement(
	          'li',
	          { className: 'icon' },
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.github.com/praagyajoshi', target: '_blank' },
	            _react2.default.createElement('i', { className: 'fa fa-github' })
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'icon' },
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.twitter.com/praagyajoshi', target: '_blank' },
	            _react2.default.createElement('i', { className: 'fa fa-twitter' })
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'icon' },
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.linkedin.com/in/praagyajoshi', target: '_blank' },
	            _react2.default.createElement('i', { className: 'fa fa-linkedin' })
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'icon' },
	          _react2.default.createElement(
	            'a',
	            { href: 'mailto:hello@praagya.com', target: '_blank' },
	            _react2.default.createElement('i', { className: 'fa fa-envelope' })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'small' },
	        'Built with \u2764\uFE0F using ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://www.gatsbyjs.org/', target: '_blank' },
	          'GatsbyJS'
	        )
	      )
	    );
	  };
	
	  return Links;
	}(_react.Component);
	
	exports.default = Links;
	module.exports = exports['default'];

/***/ }),

/***/ 364:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ExperienceSection = __webpack_require__(206);
	
	var _ExperienceSection2 = _interopRequireDefault(_ExperienceSection);
	
	var _ProjectsSection = __webpack_require__(207);
	
	var _ProjectsSection2 = _interopRequireDefault(_ProjectsSection);
	
	var _About = __webpack_require__(208);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _Links = __webpack_require__(209);
	
	var _Links2 = _interopRequireDefault(_Links);
	
	__webpack_require__(366);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'index' },
	    _react2.default.createElement(
	      'div',
	      { className: 'main' },
	      _react2.default.createElement(
	        'h5',
	        null,
	        'Hi, I\'m ',
	        _react2.default.createElement(
	          'span',
	          { className: 'bold' },
	          'Praagya Joshi'
	        )
	      ),
	      _react2.default.createElement(
	        'h3',
	        { className: 'bold' },
	        'Full stack product engineer with 3 years\' experience building products with a leading food tech company, an early stage fitness start up and a leading SaaS provider.'
	      ),
	      _react2.default.createElement(_ExperienceSection2.default, null),
	      _react2.default.createElement(_ProjectsSection2.default, null)
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'aside' },
	      _react2.default.createElement(
	        'div',
	        { className: 'top' },
	        _react2.default.createElement(_About2.default, null)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'bottom' },
	        _react2.default.createElement(_Links2.default, null)
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ }),

/***/ 366:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-5e004aa0bcae871c4438.js